var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form",
                {
                  staticClass: "mt_10",
                  attrs: {
                    model: _vm.form,
                    size: "small",
                    "label-position": "top",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c("FormDatePicker", {
                        attrs: {
                          val: _vm.form.month,
                          valueformat: "yyyyMM",
                          type: "month",
                          clearable: false,
                          editable: false,
                          placeholder: _vm.$t(
                            "storeComponents.common.pleaseSelectMonth"
                          ),
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.form, "month", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "progressGroup mt_20" }, [
        _c(
          "div",
          { staticClass: "pItem" },
          [
            _c("div", { staticClass: "pLabel" }, [
              _vm._v(_vm._s(_vm.$t("storeComponents.common.targetSalesMonth"))),
            ]),
            _vm._v(" "),
            _c("el-progress", {
              staticClass: "pProgress",
              attrs: {
                percentage:
                  _vm.orderPecent.salesTargetQty > 100
                    ? 100
                    : _vm.orderPecent.salesTargetQty,
                color: "#004EA8",
                "stroke-width": 16,
                "show-text": false,
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "pNumber" }, [
              _vm._v(
                _vm._s(
                  "" +
                    _vm.paddingNum(_vm.sourceData.salesTargetQty) +
                    _vm.$t("storeComponents.title.item2")
                )
              ),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pItem" },
          [
            _c("div", { staticClass: "pLabel" }, [
              _vm._v(_vm._s(_vm.$t("storeComponents.common.numberOfOrders"))),
            ]),
            _vm._v(" "),
            _c("el-progress", {
              staticClass: "pProgress",
              attrs: {
                percentage:
                  _vm.orderPecent.orderQty > 100
                    ? 100
                    : _vm.orderPecent.orderQty,
                color: "#A7CAF2",
                "stroke-width": 16,
                "show-text": false,
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "pNumber" }, [
              _vm._v(
                _vm._s(
                  "" +
                    _vm.paddingNum(_vm.sourceData.orderQty) +
                    _vm.$t("storeComponents.title.item2")
                )
              ),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pItem" },
          [
            _c("div", { staticClass: "pLabel" }, [
              _vm._v(_vm._s(_vm.$t("dashboard.orderTarget_confirmedQty"))),
            ]),
            _vm._v(" "),
            _c("el-progress", {
              staticClass: "pProgress",
              attrs: {
                percentage:
                  _vm.orderPecent.confirmedQty > 100
                    ? 100
                    : _vm.orderPecent.confirmedQty,
                color: "#FEDB00",
                "stroke-width": 16,
                "show-text": false,
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "pNumber" }, [
              _vm._v(
                _vm._s(
                  "" +
                    _vm.paddingNum(_vm.sourceData.confirmedQty) +
                    _vm.$t("storeComponents.title.item2")
                )
              ),
            ]),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }